import { useState } from "react";
import { MessageCircle, Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

// Share a public case/seeker link via WhatsApp or copy-to-clipboard.
export function ShareButton({ url, text, testid, compact = false }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const fullUrl = url.startsWith("http") ? url : `${window.location.origin}${url}`;
  const waHref = `https://wa.me/?text=${encodeURIComponent(`${text} ${fullUrl}`)}`;

  const copy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      toast.success(t("share.copied"));
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error(t("share.copyError"));
    }
  };

  return (
    <div className="flex gap-2 w-full">
      <a href={waHref} target="_blank" rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        data-testid={testid ? `${testid}-whatsapp` : undefined}
        className="flex-1 min-h-[36px] flex items-center justify-center gap-1 text-sm font-semibold rounded-sm bg-[#166534] text-white hover:opacity-90">
        <MessageCircle className="w-4 h-4" /> {t("share.whatsapp")}
      </a>
      <button type="button" onClick={copy}
        data-testid={testid ? `${testid}-copy` : undefined}
        className="flex-1 min-h-[36px] flex items-center justify-center gap-1 text-sm font-semibold rounded-sm bg-white border border-neutral-300 text-neutral-800 hover:bg-neutral-50">
        {copied ? <Check className="w-4 h-4 text-[#166534]" /> : <Copy className="w-4 h-4" />}
        {compact ? t("share.link") : t("share.copyLink")}
      </button>
    </div>
  );
}
